import './App.css';
import React, { useState } from 'react';
import Navbar from './Components/Navbar';
import News from './Components/News';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoadingBar from 'react-top-loading-bar';

const App = () => {
  const pagesize = 6;
  const apikey = process.env.REACT_APP_NEWS_API;

  const [progress, setprogress] = useState(0);

  return (
    <div>
      <Router>
        <Navbar />
        <LoadingBar
          height={5}
          color='rgb(0 21 255)'
          progress={progress}
        />
        <Routes>
          <Route exact path="/" element={<News setprogress={setprogress} apikey={apikey} key="general" pagesize={pagesize} query="India" />} />
          <Route exact path="/business" element={<News setprogress={setprogress} apikey={apikey} key="business" pagesize={pagesize} query="business India" />} />
          <Route exact path="/entertainment" element={<News setprogress={setprogress} apikey={apikey} key="entertainment" pagesize={pagesize} query="entertainment India" />} />
          <Route exact path="/health" element={<News setprogress={setprogress} apikey={apikey} key="health" pagesize={pagesize} query="health India" />} />
          <Route exact path="/science" element={<News setprogress={setprogress} apikey={apikey} key="science" pagesize={pagesize} query="science India" />} />
          <Route exact path="/sports" element={<News setprogress={setprogress} apikey={apikey} key="sports" pagesize={pagesize} query="sports India" />} />
          <Route exact path="/technology" element={<News setprogress={setprogress} apikey={apikey} key="technology" pagesize={pagesize} query="technology India" />} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
